var _path, _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgContentRatingS = function SvgContentRatingS(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 1.34315 1.34315 0 3 0H18C19.6569 0 21 1.34315 21 3V18C21 19.6569 19.6569 21 18 21H3C1.34315 21 0 19.6569 0 18V3Z",
    fill: "#929497"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2284_11036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0094 5.66984C14.925 5.79212 14.8366 5.88383 14.7445 5.94497C14.6524 5.99932 14.399 6.02649 14.399 6.02649C14.2531 6.02649 14.088 5.97215 13.9037 5.86345C13.7271 5.75476 13.5044 5.63587 13.2356 5.50679C12.9745 5.37092 12.6635 5.24864 12.3026 5.13995C11.9417 5.02446 11.5117 4.96671 11.0126 4.96671C10.5518 4.96671 10.1449 5.01766 9.79162 5.11957C9.44607 5.22147 9.15428 5.36413 8.91623 5.54755C8.67819 5.73098 8.49773 5.94837 8.37487 6.19973C8.25969 6.44429 8.20209 6.71264 8.20209 7.00476C8.20209 7.3784 8.31344 7.6909 8.53613 7.94226C8.75881 8.18682 9.05061 8.39742 9.41152 8.57405C9.78011 8.75068 10.1986 8.90693 10.667 9.0428C11.1354 9.17187 11.6115 9.31114 12.0953 9.4606C12.5867 9.61005 13.0667 9.77989 13.5351 9.97011C14.0035 10.1603 14.4182 10.4015 14.7791 10.6936C15.1476 10.9857 15.4433 11.3424 15.666 11.7636C15.8887 12.1848 16 12.6977 16 13.3023C16 13.9545 15.8733 14.5659 15.6199 15.1365C15.3665 15.7072 14.9979 16.2065 14.5141 16.6345C14.038 17.0557 13.4468 17.3886 12.7403 17.6332C12.0415 17.8777 11.2429 18 10.3445 18C9.81466 18 9.29634 17.9524 8.78953 17.8573C8.2904 17.769 7.81047 17.6433 7.34974 17.4803C6.89668 17.3105 6.47051 17.1067 6.0712 16.8689C5.6719 16.6311 5.31483 16.3662 5 16.074L5.78325 14.9327C5.85236 14.8376 5.94066 14.7629 6.04817 14.7086C6.15567 14.6542 6.27469 14.627 6.40524 14.627C6.58185 14.627 6.77766 14.7018 6.99267 14.8512C7.20768 14.9939 7.46492 15.1535 7.7644 15.3302C8.07155 15.5 8.44014 15.6596 8.87016 15.8091C9.30017 15.9518 9.81466 16.0231 10.4136 16.0231C11.3888 16.0231 12.1414 15.8125 12.6712 15.3913C13.2087 14.9701 13.4775 14.3893 13.4775 13.6488C13.4775 13.2344 13.3661 12.8981 13.1435 12.6399C12.9208 12.375 12.6251 12.1542 12.2565 11.9776C11.8956 11.801 11.481 11.6515 11.0126 11.5292C10.5442 11.4069 10.0681 11.2779 9.58429 11.142C9.10052 10.9993 8.62443 10.8363 8.15602 10.6529C7.68761 10.4626 7.26911 10.2181 6.90052 9.91916C6.53962 9.61345 6.24782 9.23981 6.02513 8.79823C5.80244 8.34986 5.6911 7.7928 5.6911 7.12704C5.6911 6.59715 5.80628 6.08424 6.03665 5.58832C6.27469 5.09239 6.61641 4.65421 7.06178 4.27378C7.51483 3.88655 8.07155 3.57745 8.73194 3.34647C9.39232 3.11549 10.1449 3 10.9895 3C11.9417 3 12.8133 3.13247 13.6042 3.39742C14.4028 3.66236 15.0901 4.0394 15.666 4.52853L15.0094 5.66984Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2284_11036",
    x: 3,
    y: 1,
    width: 15,
    height: 19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2284_11036"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2284_11036",
    result: "shape"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContentRatingS, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/content_rating_s.f5f8c805.svg";
export { ForwardRef as ReactComponent };